export default __webpack_public_path__ + "static/home-bg-32161f4db72f3a0737be7b86b0bdd315.jpg";